<template>
<div>
  <CCard>
    <CCardHeader>
      <strong>Landing Banner</strong>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="landing_img_url">
        <CCol sm="12" >
          <img :src="landing_img_url" style="width: 300px" />
          <CButton color="danger" @click="removeImageLandingBanner(landing_banner.image.id)">Remove Banner</CButton>
        </CCol>
      </CRow>
        <CRow v-else>
          <CCol>
             <span>No landing banner is set currently</span>
          </CCol>
         
        </CRow>

        <CInputFile
          vertical
          ref="file"
          type="file"
          id="file"
          @change="onImageChangeLanding"
        />
        <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
        <label class="text-danger"
          >(Image Size should be (750 X 126) and less than 1 MB)</label
        ><br />
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmitLandingBanner" color="primary">
        <CIcon name="cil-check-circle" />Update Banner
      </CButton>
    </CCardFooter>
  </CCard>
  

    <CCard>
    <CCardHeader>
      <strong>Start Play Banner</strong>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="start_play_banner.image">
        <CCol sm="12" >
          <img :src="start_play_img_url" style="width: 300px" />
          <CButton color="danger" @click="removeImageStartPlay(start_play_banner.image.id)">Remove Banner</CButton>
        </CCol>
      </CRow>
        <CRow v-else>
          <CCol>
             <span>No start play banner is set currently</span>
          </CCol>
         
        </CRow>

        <CInputFile
          vertical
          ref="file"
          type="file"
          id="file"
          @change="onImageChangeStartPlay"
        />
        <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
        <label class="text-danger"
          >(Image Size should be (750 X 126) and less than 1 MB)</label
        ><br />
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmitStartPlayBanner" color="primary">
        <CIcon name="cil-check-circle" />Update Banner
      </CButton>
    </CCardFooter>
  </CCard>


      <CCard>
    <CCardHeader>
      <strong>Sliding Banner</strong>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="existingSlidingBanners">
        <CCol sm="12" v-for="img in existingSlidingBanners" :key="img.id">
          <img :src="root_url + img.url" style="width: 300px" />
          <CButton color="danger" @click="removeImageSlidingBanners(img.id)"> Remove Banner </CButton>
        </CCol>
      </CRow>
        <CRow v-else>
          <CCol>
             <span>No sliding banners is set currently</span>
          </CCol>
         
        </CRow>

        <CInputFile
          vertical
          ref="file"
          type="files"
          id="file"
          multiple="multiple"
          @change="onImageChangeSlidingBanners"
        />
        <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
        <label class="text-danger"
          >(Image Size should be (768 x 305) and less than 1 MB)</label
        ><br />
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmitSlidingBanners" color="primary">
        <CIcon name="cil-check-circle" />Update Banner
      </CButton>
    </CCardFooter>
  </CCard>
</div>

</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const ROOT_URL = process.env.VUE_APP_ROOT_URL;
const id = window.location.pathname.split("/").pop();
export default {
  name: "PromotionEdit",
  data() {
    return {
      root_url: ROOT_URL + "/",
      promotion: {},
      landing_img_url: "",
      start_play_img_url: "",
      landing_banner: {},
      start_play_banner: {},
      sliding_banners: [],
      existingSlidingBanners: []
    };
  },
  created() {
    this.getImages();
  },
  methods: {
    getImages() {
      this.$axios
        .get(`${ADMIN_URL}/get-bkash-banners`)
        .then((response) => {
          this.landing_banner.image = this.search('landing_banner', response.data) 
          this.landing_img_url = ROOT_URL + "/" +  this.landing_banner.image.url;

          this.start_play_banner.image = this.search('start_play_banner', response.data) 
          this.start_play_img_url = ROOT_URL + "/" +  this.start_play_banner.image.url;
          this.getAllSlidingBanners(response.data);
         
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },

    search(nameKey, myArray){
      for (var i=0; i < myArray.length; i++) {
          if (myArray[i].banner_type === nameKey) {
              return myArray[i];
          }
      }
    },

    getAllSlidingBanners(arr) 
    {
        for (var i=0; i < arr.length; i++) {
          if (arr[i].banner_type === 'slider_banners') {
               this.existingSlidingBanners.push(arr[i]);
          }
        }
    },

    onImageChangeStartPlay(e) {
      const file = e[0];
      if (file === undefined) {
        return;
      }
      this.start_play_banner.image = file;
      this.start_play_img_url = URL.createObjectURL(file);
    },

    onImageChangeLanding(e) {
      const file = e[0];
      if (file === undefined) {
        return;
      }
     
      this.landing_banner.image = file;
      this.landing_img_url = URL.createObjectURL(file);
    },

    onImageChangeSlidingBanners(e)
    {
      e.forEach(function(item,index) {
          const file = item;
          if (file === undefined) {
              return;
            }
          this.sliding_banners.push(file);
      }.bind(this));
     
    },

    removeImageLandingBanner(id) {
      (this.landing_img_url = ""), (this.landing_banner.image = "");
      this.deleteBanner(id);
    },

    removeImageStartPlay(id) {
      (this.start_play_img_url = ""), (this.start_play_banner.image = "");
      this.deleteBanner(id);
    },

    removeImageSlidingBanners(id) {
      this.deleteBanner(id);
    },

    onSubmitLandingBanner(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("type", "landing_banner");
      formData.append("image", this.landing_banner.image);
      formData.append("_method", "put");

      this.$axios
        .post(`${ADMIN_URL}/bkash-banner`, formData, config)
        .then((response) => {
          this.$swal("Updated Successfully", "success");
          // this.landing_banner.image = this.search('start_play_banner', response.data) 
          // this.landing_img_url = ROOT_URL + "/" +   this.landing_banner.image.url;
      
        })
        .catch((error) => {
          console.log(error)
          // currentObj.output = error;
          // this.$swal("Error", error.response.message, "error");
        });
    },

    onSubmitStartPlayBanner(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("type", "start_play_banner");
      formData.append("image", this.start_play_banner.image);
      formData.append("_method", "put");

      this.$axios
        .post(`${ADMIN_URL}/bkash-banner`, formData, config)
        .then((response) => {
            this.$swal("Updated Successfully", "success");
            window.location.reload();
        })
        .catch((error) => {
          currentObj.output = error;
          this.$swal("Error", error.response.message, "error");
        });
    },

    onSubmitSlidingBanners(e) {

     
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
       formData.append("type", "slider_banners");
       this.sliding_banners.forEach(function(item,index) {
            formData.append('images[' + index + ']', item);
       });
      formData.append("_method", "put");
     
      this.$axios
        .post(`${ADMIN_URL}/bkash-banner`, formData, config)
        .then((response) => {
            this.$swal("Updated Successfully", "success");
        window.location.reload();
        })
        .catch((error) => {
          currentObj.output = error;
          this.$swal("Error", error.response.message, "error");
        });
    },


    deleteBanner(id) {
       let formData = new FormData();
      formData.append("id", id);
      formData.append("_method", "post");

      this.$axios
        .post(`${ADMIN_URL}/bkash-banner/delete`, formData)
        .then((response) => {
          window.location.reload(); 
        })
        .catch((error) => {
          console.log(error)
       
        });
    },
  
  },

};
</script>

<style scoped>
</style>
